import bem from 'utils/bem';

export const block = bem('bluesky-autopost-modal');
